import React from "react";
import { Dialog, DialogContent, TextField, Grid, DialogActions, Button, DialogTitle, Divider, } from "@material-ui/core";
import { SelectListField } from "../../../common/SelectListField";
import { useFormState } from "../../../../hooks/useFormState";
import { useDispatch } from "react-redux";
import { submitActivityTransfer } from "../../../../redux/actions";
import { usersService } from "../../../../services";
import { teamsService } from "../../../../services";
const MULTILINE_ROW_HEIGHT = 8;
export const TransferCaseDialog = ({ isDialogOpen, onDialogClose, caseId, }) => {
    const dispatch = useDispatch();
    const { formProps, triggerSubmit, triggerReset, state, handleOnChange } = useFormState({
        teamId: "",
        userId: "",
        noteBody: "",
    }, ["teamId", "noteBody"], ({ state }) => {
        dispatch(submitActivityTransfer(caseId, state.values));
        onDialogClose();
        triggerReset();
    });
    return (React.createElement(Dialog, { open: isDialogOpen, onClose: () => {
            onDialogClose();
            triggerReset();
        }, maxWidth: "md", fullWidth: true },
        React.createElement(DialogTitle, null, "Transfer Case"),
        React.createElement(Divider, null),
        React.createElement(DialogContent, null,
            React.createElement("form", null,
                React.createElement(Grid, { container: true, spacing: 3 },
                    React.createElement(Grid, { item: true, xs: 12, sm: 12 },
                        React.createElement(SelectListField, Object.assign({}, formProps("teamId"), { 
                            // because the list of user ids depends on teamId, we hand write the onChange logic to
                            //  be able to reset the userId field if it has been set and the user now changes team id
                            onChange: target => {
                                var _a;
                                // the standard logic for this field that is also provided by '...formProps("teamId")'
                                handleOnChange({ name: "teamId", value: (_a = target === null || target === void 0 ? void 0 : target.currentTarget) === null || _a === void 0 ? void 0 : _a.value });
                                if (state.values.userId) {
                                    // now we can also call the user Id change function
                                    handleOnChange({ name: "userId", value: "" });
                                }
                            }, label: "Transfer to team", service: teamsService }))),
                    React.createElement(Grid, { item: true, xs: 12, sm: 12 },
                        React.createElement(SelectListField, Object.assign({}, formProps("userId"), { label: "Assign to user", service: {
                                getAll: () => usersService.getAll({ teamId: state.values.teamId }),
                            }, disabled: !state.values.teamId }))),
                    React.createElement(Grid, { item: true, xs: 12, sm: 12 },
                        React.createElement(TextField, Object.assign({ variant: "outlined" }, formProps("noteBody"), { label: "Note", fullWidth: true, multiline: true, rows: MULTILINE_ROW_HEIGHT })))))),
        React.createElement(DialogActions, null,
            React.createElement(Button, { onClick: () => triggerSubmit(), "data-test": "dialog-ok", color: "primary" }, "Transfer"))));
};
